import {AuthContextInterface} from '../components/AuthProvider'
import {ApiError} from '../error/apiError.class'
import {toast} from 'sonner'

export const useApi = async (
  auth: AuthContextInterface | null,
  url: string,
  options: any = {},
  origin?: string,
) => {
  const checkStatus = async (res: Response) => {
    if (res.ok) {
      return res
    } else {
      const payload = await res.json()

      if (res.status >= 500) {
        toast(
          'Something went wrong, please contact support and provide the Request Id!',
          {
            description: `Request Id: ${payload?.requestStatus?.requestId}`,
            duration: Infinity,
            cancel: {
              label: 'Dismiss',
              onClick: () => {},
            },
          },
        )
      }

      if (payload.errors && payload.errors.length > 0) {
        throw new ApiError(payload.errors[0], payload)
      } else if (payload.error && payload.error.message) {
        throw new ApiError(payload.error.message, payload)
      } else {
        throw new ApiError(res.statusText, payload)
      }
    }
  }

  options.headers = options.headers || {}
  if (options.headers && options.headers['Content-Type'] === 'Automatic') {
    delete options.headers['Content-Type']
  } else {
    options.headers['Content-Type'] = 'application/json'
  }

  if (origin !== 'network') {
    if (
      process.env.REACT_APP_X_MEMBER_ID &&
      process.env.REACT_APP_X_MEMBER_ID !== 'blank'
    ) {
      options.headers['X-Member-Id'] = process.env.REACT_APP_X_MEMBER_ID
    }

    if (
      process.env.REACT_APP_MEMBER_ACCESS_HEADER &&
      process.env.REACT_APP_MEMBER_ACCESS_HEADER !== 'blank'
    ) {
      options.headers['X-Member-Access'] =
        process.env.REACT_APP_MEMBER_ACCESS_HEADER
    }
  }

  let baseUrl = url

  if (baseUrl.indexOf('https') === -1) {
    if (origin === 'network') {
      //GO SERVICES ENDPOINT
      baseUrl = `${process.env.REACT_APP_CHECKOUT_API_URL}${url}`
    } else {
      //NODE SERVICES ENDPOINT BY DEFAULT
      baseUrl = `${process.env.REACT_APP_BKS_PLATFORM_SERVICES_URL}${url}`
    }
  }

  if (auth) {
    const accessToken = auth.getAuthToken()

    return fetch(baseUrl, {
      ...options,
      headers: {
        // Add the Authorization header to the existing headers
        Authorization: `Bearer ${accessToken}`,
        ...options.headers,
      },
    }).then(checkStatus)
  } else {
    return fetch(baseUrl, {
      ...options,
      headers: {
        ...options.headers,
      },
    }).then(checkStatus)
  }
}
